<template>
  <section class="c-section c-section--home">
    <div
      class="c-banner pt-2 pt-lg-5"
    >
      <div v-if="context.post" class="c-banner__background-under">
        <div id="slider-banner" class="swiper h-100">
          <div class="swiper-wrapper h-100">
            <div
              v-for="(background, ibackground) of context.banner_top.background"
              :key="`bg-${ibackground}`"
              class="swiper-slide h-100"
            >
              <figure class="h-100">
                <img
                  :src="background.url"
                  class="w-100 h-100 of--cover"
                  alt="Agro Club"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
      <div class="c-banner__background"></div>

      <div class="c-banner__content position-relative container">
        <div class="row">
          <div class="col-12 col-md-10 col-lg-7">
            <div class="c-banner__texts pt-5 mt-5">
              <b-skeleton-wrapper :loading="contextLoading">
                <template #loading>
                  <b-skeleton width="80%" height="60px" class="mb-4"></b-skeleton>
                  <b-skeleton width="60%" height="20px" class="mb-4"></b-skeleton>
                  <b-skeleton width="100%" class="mb-5"></b-skeleton>
                  <b-skeleton width="20%" height="30px"></b-skeleton>
                </template>

                <h1 class="c-banner__title mb-2">
                  {{context.banner_top ? context.banner_top.title : '' }}
                </h1>
                <h2 class="pri-color fs-30 w-sbold mb-5">
                  {{context.banner_top ? context.banner_top.subtitle : '' }}
                </h2>
                <div
                  class="gray-light fs-16 mb-5"
                  v-html="context.banner_top ? context.banner_top.description : ''">
                </div>
                <a
                  :href="bannerButton.link"
                  class="c-button c-button--primary mb-5 d-inline-block"
                >
                  {{bannerButton.title}}
                </a>
              </b-skeleton-wrapper>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="context.post" class="c-choose">
      <div class="container">
        <div class="c-choose__container mb-5">
          <div class="c-choose__contain-back mt-5">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8" v-if="context.why">
                <div
                  v-html="context.why.title"
                  class="c-title fs-35 w-sbold white pt-5 pb-4 text-center">
                </div>
                <p class="fs-20 gray-light text-center pb-5">
                  {{context.why.description}}
                </p>
              </div>
            </div>
            <div class="row gx-5">
              <div
                class="col-12 col-md-6 col-lg-3"
                v-for="(choos, ichoos) of context.why.reasons"
                :key="`choos-${ichoos}`"
              >
                <div class="c-choose__column">
                  <div class="d-flex justify-content-center align-items-center">
                    <figure class="c-choose__figure">
                      <img
                        :src="`${choos.icon.url}`"
                        alt="" class="c-choose__img"
                      >
                    </figure>
                  </div>
                  <h2 class="fs-25 white w-sbold text-center pt-5 pb-2">
                    {{choos.title}}
                  </h2>
                  <p class="gray-light fs-16 text-center">
                    {{choos.description}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="c-text-background">
            <h2 class="c-text-background__text">
              ¿PORQUÉ?
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-sec-color">
      <div class="container">
        <div class="c-curses">
          <section class="py-5">
            <section class="c-slider-courses mb-5" :class="{hide : courses.isFirstReady}">
              <div class="c-slider-courses__loading">
                <div class="row gy-5">
                  <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4 col-xl-3
                      d-none d-md-block"
                  >
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4 col-xl-3
                      d-none d-lg-block"
                  >
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4 col-xl-3
                      d-none d-xl-block"
                  >
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-slider-courses__data">
                <section
                  class="py-5"
                >
                  <div
                    @mouseover="pauseSliderCourses(1, true)"
                    @mouseleave="pauseSliderCourses(1, false)"
                    id="slider-courses-one"
                    class="swiper">
                    <div class="swiper-wrapper">
                      <div
                        v-for="course of courses.data.first"
                        :key="`course-${course.id}`"
                        class="swiper-slide"
                      >
                        <Course :body="course" />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </section>

            <section class="c-slider-courses" :class="{hide : courses.isSecondReady}">
              <div class="c-slider-courses__loading">
                <div class="row gy-5">
                  <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4 col-xl-3
                      d-none d-md-block"
                  >
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4 col-xl-3
                      d-none d-lg-block"
                  >
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4 col-xl-3
                      d-none d-xl-block"
                  >
                    <div class="row gy-2">
                      <div class="col-12">
                        <b-skeleton width="100%" height="130px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="90%" height="20px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-slider-courses__data">
                <section
                  class="py-5"
                >
                  <div
                    @mouseover="pauseSliderCourses(2, true)"
                    @mouseleave="pauseSliderCourses(2, false)"
                    id="slider-courses-two"
                    class="swiper">
                    <div class="swiper-wrapper">
                      <div
                        v-for="course of courses.data.second"
                        :key="`course-${course.id}`"
                        class="swiper-slide"
                      >
                        <Course :body="course" />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </section>
          </section>

          <div class="c-text-background w-100">
            <h2 class="c-text-background__text text-center">
              CURSOS
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div v-if="context.post" class="bg-sec-color pb-5">
      <div class="container">
        <div class="c-memberships pb-5">
          <div class="row justify-content-center">
            <div class="col-12 col-md-10">
              <div
                v-html="context.memberships.title"
                class="c-title white fs-35 w-sbold text-center">
              </div>
              <div
                v-html="context.memberships.description"
                class="c-title white fs-35 w-sbold text-center mb-5 pb-5">
              </div>
            </div>
          </div>

          <b-skeleton-wrapper :loading="memberships.loading">
            <template #loading>
              <div class="row justify-content-center gx-5 gy-5">
                <div class="col-12 col-md-6 col-lg-5">
                  <b-skeleton height="500px"></b-skeleton>
                </div>
                <div class="col-12 col-md-6 col-lg-5">
                  <b-skeleton height="500px"></b-skeleton>
                </div>
              </div>
            </template>

            <div class="d-md-flex py-5">
              <div
                v-if="memberships.data.month && !isAlreadyMonthSubsriber"
                class="w-100 mb-4 mb-md-0"
              >
                <MembershipCard
                  variant="fresh"
                  plan="month"
                  :body="memberships.data.month"
                  :subscriber="userSubscriber"
                />
              </div>
              <div v-if="memberships.data.anual" class="w-100">
                <MembershipCard
                  plan="anual"
                  :body="memberships.data.anual"
                  :subscriber="userSubscriber"
                />
              </div>
            </div>
          </b-skeleton-wrapper>
          <div class="c-text-background c-text-background--top">
            <h2 class="c-text-background__text text-center">
              MEMBRESÍAS
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div v-if="context.post" class="bg-sec-color pb-5">
      <div class="container">
        <div class="position-relative">
          <div class="row gy-5">
            <div class="col-12 col-md-6 col-lg-4 order-2 orden-md-1">
              <SpecialistCard
                v-if="context.specialists && context.specialists.main"
                :body="context.specialists.main"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-8 order-1 order-md-2">
              <div class="p-2 p-lg-5">
                <div v-html="context.specialists.title" class="c-title fs-35 w-sbold white mb-4">
                </div>
                <div v-html="context.specialists.subtitle" class="fs-21 gray-light mb-5">
                </div>
                <div class="d-flex flex-column flex-md-row align-items-center">
                  <div class="mb-4 mb-md-0 me-md-4">
                    <router-link to="/especialistas" class="c-button c-button--primary">
                      Ver Especialistas
                      <span class="ms-2 white">
                        <Icon icon="akar-icons:arrow-right" class="fs-21" />
                      </span>
                    </router-link>
                  </div>
                  <div>
                    <router-link
                      to="/especialistas-contacto"
                      class="c-button c-button--white-ghost"
                    >
                      Quiero ser un Especialista
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="context.specialists && context.specialists.secondary" class="row">
            <div class="col-12 col-md-6 col-lg-4 d-none d-lg-block">
            </div>
            <div
              v-for="(specialist, ispecialist) of context.specialists.secondary"
              :key="`specialist-sec-${ispecialist}`"
              class="col-12 col-md-6 col-lg-4"
            >
              <SpecialistCard :body="specialist"/>
            </div>
          </div>
          <div class="c-text-background c-text-background--top w-100">
            <h2 class="c-text-background__text text-center">
              Especialistas
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-sec-color py-5">
      <div class="container">
        <BannerFooter />
      </div>
    </div>
  </section>
</template>

<script>
import {
  Swiper,
  Autoplay,
} from 'swiper';

export default {
  data() {
    return {
      context: {},
      contextLoading: true,

      sliderCoursesOne: null,
      sliderCoursesTwo: null,

      memberships: {
        data: {
          month: null,
          anual: null,
        },
        loading: false,
      },

      courses: {
        data: {
          first: [],
          second: [],
        },
        isFirstReady: false,
        isSecondReady: false,
      },

      userSubscriber: false,
    };
  },
  components: {
    Course: () => import(/* webpackChunkName: "course" */'../components/Course.vue'),
    MembershipCard: () => import(/* webpackChunkName: "membership-card" */'../components/MembershipCard.vue'),
    SpecialistCard: () => import(/* webpackChunkName: "specialist-card" */'../components/SpecialistCard.vue'),
    BannerFooter: () => import(/* webpackChunkName: "banner-footer" */'../components/footer/Banner.vue'),
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.stateUser;
    },

    bannerButton() {
      return this.context?.banner_top?.button
        ? { title: this.context.banner_top.button.title, link: this.context.banner_top.button.link }
        : { title: 'Escoge los cursos aquí', link: '/cursos' };
    },

    isAlreadyMonthSubsriber() {
      return (this.isAuthenticated)
        ? this.userData.subscriber && this.userData.subscriber_plan === 'month'
        : false;
    },
  },
  watch: {
    contextLoading(value) {
      if (!value) {
        this.initSliderBanner();
      }
    },
  },
  created() {
    if (this.$route.query.p && this.$route.query.preview) {
      this.$router.push({
        path: `/blog/preview/${this.$route.query.p}`,
      }).catch(() => {});
    }

    this.getFullContext({ type: 'page', slug: 'inicio' });
    this.getMemberships();
    this.getCourses(1);
    this.getCourses(2);
  },
  methods: {
    initSliderCourses(number) {
      window.setTimeout(() => {
        const options = {
          modules: [Autoplay],

          speed: 900,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          spaceBetween: 30,

          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1140: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },

          on: {
            init: () => {
              window.setTimeout(() => {
                if (number === 1) {
                  this.courses.isFirstReady = true;
                } else {
                  this.courses.isSecondReady = true;
                }
              }, 1000);
            },
          },
        };
        const sliderId = (number === 1)
          ? '#slider-courses-one'
          : '#slider-courses-two';

        this.sliderCoursesOne = new Swiper(sliderId, options);
      }, 200);
    },
    initSliderBanner() {
      window.setTimeout(() => {
        this.sliderBanner = new Swiper('#slider-banner', {
          modules: [Autoplay],

          speed: 1500,
          loop: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        });
      }, 1000);
    },

    pauseSliderCourses(slider, mode) {
      const sliderCourses = (slider === 1) ? this.sliderCoursesOne : this.sliderCoursesTwo;

      if (sliderCourses) {
        if (mode) sliderCourses.autoplay.stop();
        else sliderCourses.autoplay.start();
      }
    },

    getMemberships() {
      const request = `${process.env.VUE_APP_API}/memberships`;

      this.memberships.isLoading = true;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            const membershipMonth = response.data.month;
            const membershipAnual = response.data.anual;

            this.memberships.data = {
              month: {
                title: 'MENSUAL',
                has_discount: membershipMonth.has_discount,
                discount: Number(membershipMonth.amount_before)
                  - Number(membershipMonth.amount_current),
                amounts: {
                  before: Number(membershipMonth.amount_before),
                  current: Number(membershipMonth.amount_current),
                  symbol: membershipMonth.symbol,
                },
                button: {
                  path: '/checkout/membership?plan=month',
                  name: 'Comprar Plan Mensual',
                },
                description: membershipMonth.description,
                benefits: membershipMonth.benefits,
              },
              anual: {
                ...this.membershipAnual,
                title: 'ANUAL',
                has_discount: membershipAnual.has_discount,
                discount: Number(membershipAnual.amount_before)
                  - Number(membershipAnual.amount_current),
                amounts: {
                  before: Number(membershipAnual.amount_before),
                  current: Number(membershipAnual.amount_current),
                  symbol: membershipAnual.symbol,
                },
                button: {
                  path: '/checkout/membership?plan=anual',
                  name: 'Comprar Plan Anual',
                },
                description: membershipAnual.description,
                benefits: membershipAnual.benefits,
              },
            };

            this.userSubscriber = response.subscriber;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.memberships.isLoading = false;
        });
    },
    getCourses(paged) {
      const request = `${process.env.VUE_APP_API}/courses?per_page=12&paged=${paged}`;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            if (paged === 1) {
              this.courses.data.first = response.data.courses;
            } else {
              this.courses.data.second = response.data.courses;
            }

            this.initSliderCourses(paged);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
